import { render, staticRenderFns } from "./ABTest.vue?vue&type=template&id=166d3d39&"
import script from "./ABTest.vue?vue&type=script&lang=js&"
export * from "./ABTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports